import React from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Container, Button, Row, Col } from "reactstrap";
import classNames from "classnames";
import Countdown, { zeroPad } from "react-countdown";
import moment from "moment";

import {
  getPreviewRaffle,
  getUserRaffleTickets,
  getRaffleGroup
} from "../../actions/kafairAction";
import { sliderBanner } from "../../actions/slidersAction";
import { doFetchProfile } from "../../actions/authAction";

import { Banner, Content } from "../Assets";
import CardLoading from "../../components/Loading/CardLoading";
import FilterAndSort from "../../components/PageSearchDetails/FilterAndSort";
import { isFromAppBrowser, getCloudImageUrl } from "../../utils";
import SneakerImage from "../../components/Sneakers/SneakerImage";
import { TextRupiah } from "../../components/Text";
import { ModalAlert, ModalLoginNew } from "../../components/Modals";

const goldenTicket = require("../../images/golden-ticket.png");
const standardTicket = require("../../images/standard-ticket.png");

const renderer = ({ days, hours, minutes, seconds, completed }) => {
  if (completed) {
    return (
      <div>
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  } else {
    return (
      <div className="countdown-wrapper">
        <span>
          {zeroPad(days)} : {zeroPad(hours)} : {zeroPad(minutes)} :{" "}
          {zeroPad(seconds)}
        </span>
      </div>
    );
  }
};

const ProductItem = ({ item }) => {
  return (
    <Col xs={6} md={4}>
      <div className="product-card">
        <span>
          {item.product.brand.title
            ? item.product.brand.title
            : item.product.brand.name}
        </span>
        <span>{item.display_name}</span>
        <SneakerImage
          hasImage={item.product_variant_images.length > 0 ? true : false}
          src={
            item.product_variant_images.length
              ? getCloudImageUrl(item.product_variant_images[0].URL, 400)
              : null
          }
          alt={item.display_name}
        />
        <span className="text-center">Get this for</span>
        <TextRupiah
          value={item.pivot.retail_price}
          className="price-tag"
          color="black"
          bold={true}
          align="center"
        />
      </div>
    </Col>
  );
};

class RafflePreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      prevY: 0,
      loading: true,
      hasMore: true,
      imageBanner: null,
      showModalLogin: false,
      isLoggedIn: false,
      showModalInfo: false,
      messageInfo: ""
    };
  }

  componentDidMount() {
    this.fetchAll();
    if (window.Intercom) {
      window.Intercom("update", {
        hide_default_launcher: true
      });
    }
  }

  componentWillUnmount() {
    if (window.Intercom) {
      window.Intercom("update", {
        hide_default_launcher: false
      });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const { sliderImages, dataAuth } = this.props;

    if (
      !dataAuth.userdata.isFetch &&
      prevProps.dataAuth.userdata.isFetch !== dataAuth.userdata.isFetch
    ) {
      this.setState({
        isLoggedIn: dataAuth.isLogged
      });

      if (!dataAuth.isLogged) {
        this.setState({
          showModalLogin: true
        });
      }
    }

    if (
      !dataAuth.signIn.isSubmit &&
      prevProps.dataAuth.signIn.isSubmit !== dataAuth.signIn.isSubmit
    ) {
      const { error, isSubmit } = dataAuth.signIn;
      const { dataCategory } = this.props;
      if (!error) {
        await this.setState({
          showModalLogin: false,
          isLoggedIn: true
        });
        this.fetchAll();
      } else {
        await this.setState({
          showModalLogin: true,
          isLoggedIn: false
        });
      }
    }

    if (prevProps.sliderImages.isFetch !== sliderImages.isFetch) {
      const imageBanner =
        sliderImages.images.length > 0 &&
        sliderImages.images.find(
          item => item.data && item.data.type === "PREVIEW_RAFFLE_SCREEN"
        );

      this.setState({
        imageBanner: imageBanner ? imageBanner.img_url : null
      });
    }

    if (prevState.showModalLogin !== this.state.showModalLogin) {
      const { error, isSubmit } = dataAuth.signIn;

      if (!this.state.showModalLogin && !this.state.isLoggedIn && !isSubmit) {
        this.props.history.push("/");
      }
    }
  }

  fetchAll = () => {
    const { dataCategory } = this.props;
    const params = { params: { category: dataCategory } };

    this.props.getUserRaffleTickets();
    this.props.getPreviewRaffle();
    this.props.sliderBanner(params);
    this.props.getRaffleGroup();
  };

  onCloseModal = () => {
    const { dataAuth } = this.props;

    this.setState({
      showModalLogin: false
    });
  };

  _toggleModalInfo = (isGold, total) => {
    try {
      const { data } = this.props.dataRaffle;
      const group_names =
        data.length > 0 &&
        data.filter(p => p.golden == isGold).map(d => d.group_name);

      const raffle_events =
        !group_names || !group_names.length
          ? `raffle event dengan tipe ${isGold ? "golden" : "standard"} raffle`
          : group_names.length === 1
          ? group_names[0]
          : group_names.slice(0, -1).join(", ") + " & " + group_names.slice(-1);

      this.setState({
        showModalInfo: !this.state.showModalInfo,
        messageInfo: `Anda memiliki ${total} tiket untuk mengikuti ${raffle_events}`
      });
    } catch (e) {
      this.setState({
        showModalInfo: !this.state.showModalInfo,
        messageInfo: `Anda memiliki ${total} tiket untuk mengikuti raffle event dengan tipe ${
          isGold ? "golden" : "standard"
        } raffle`
      });
    }
  };

  toggleModalInfo = data => {
    const { userRaffle } = this.props;
    const user_ticket = userRaffle.data[data.ticket_type].total;

    this.setState({
      showModalInfo: !this.state.toggleModalInfo,
      messageInfo: `Anda memiliki ${user_ticket} tiket untuk mengikuti ${data.title}`
    });
  };

  render() {
    const { userRaffle, dataRaffleGroup } = this.props;
    const { data } = this.props.dataRaffle;
    const { imageBanner } = this.state;

    return (
      <Container fluid className="main-container" id="home-container">
        <ModalLoginNew
          isOpen={this.state.showModalLogin}
          onClosed={this.onCloseModal}
        />
        <ModalAlert
          isOpen={this.state.showModalInfo}
          contentText={this.state.messageInfo}
          showButton={false}
          onToggle={() => {
            this.setState({ showModalInfo: !this.state.showModalInfo });
          }}
        />
        <Banner src={imageBanner} alt="Raffle Preview KA Fair" />
        <div className="raffle-container">
          {data.length > 0
            ? data.map((item, index) => {
                const isStart = moment().isAfter(item.started_at);
                const isExpired = moment().isAfter(item.expiry);

                return (
                  <div key={index} className="raffle-group">
                    <div className="title-wrapper">
                      <span className="group-title">{item.group_name}</span>
                      <span>{isStart ? "Berakhir Dalam" : "Mulai Dalam"}</span>
                    </div>
                    <Countdown
                      date={
                        isStart
                          ? moment(item.expiry).toISOString()
                          : moment(item.started_at).toISOString()
                      }
                      daysInHours={true}
                      zeroPadTime={2}
                      renderer={renderer}
                      iStart={isStart}
                    />
                    <Container>
                      <Row className="product-wrapper">
                        {item.data.length > 0
                          ? item.data.map((item, index) => {
                              return <ProductItem item={item} />;
                            })
                          : null}
                      </Row>
                    </Container>
                  </div>
                );
              })
            : null}
        </div>

        <div className="footer-ticket">
          {dataRaffleGroup.data.length > 0 &&
            dataRaffleGroup.data.map((item, index) => {
              const ticket_bg = getCloudImageUrl(
                userRaffle.data[item.ticket_type] &&
                  userRaffle.data[item.ticket_type].ticket_img_url,
                100
              );
              return (
                <div
                  className="ticket-wrapper"
                  onClick={() => this.toggleModalInfo(item)}
                >
                  <KickImage src={ticket_bg} />
                  <span>
                    {item.ticket_name} Ticket:{" "}
                    <strong>
                      {userRaffle.data[item.ticket_type] &&
                        userRaffle.data[item.ticket_type].total}
                    </strong>
                  </span>
                </div>
              );
            })}
        </div>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  dataAuth: state.dataAuth,
  dataRaffle: state.dataKaFair.previewRaffle,
  userRaffle: state.dataKaFair.userRaffleTicket,
  sliderImages: state.sliderHome,
  dataCategory: state.dataCategory.selected,
  dataRaffleGroup: state.dataKaFair.raffleGroup
});

const mapDispatchToProps = dispatch => ({
  getPreviewRaffle: () => dispatch(getPreviewRaffle()),
  sliderBanner: payload => dispatch(sliderBanner(payload)),
  getUserRaffleTickets: () => dispatch(getUserRaffleTickets()),
  doFetchProfile: () => dispatch(doFetchProfile()),
  getRaffleGroup: () => dispatch(getRaffleGroup())
});

export default connect(mapStateToProps, mapDispatchToProps)(RafflePreview);
